/**
 * Restartable one-shot shake for elements with `.m2b-shake-once`.
 * Pair with `src/styles/m2b-motion.css` (imported from index.js).
 */
export function triggerShakeOnce(el) {
  if (!el) return;
  el.classList.remove('is-shaking');
  // Force reflow so re-clicks restart the animation mid-flight.
  void el.offsetWidth;
  el.classList.add('is-shaking');
  const done = () => {
    el.classList.remove('is-shaking');
    el.removeEventListener('animationend', done);
  };
  el.addEventListener('animationend', done);
}
